export default {
    isLoaded: false,
    url: `${location.protocol}//${process.env.VUE_APP_lib_domain}/pvcam-wc.min.js`
}
